import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { api, errMsg } from "../../lib/api";
import { Link } from "react-router-dom";
import { SectionHead } from "../Badges";

const IMGS = ["/brand/museum/opening-1.webp", "/brand/museum/bugatti-type-35.webp", "/brand/museum/porsche-356.webp"];

export const BookingForm = ({ onDone }) => {
  const [f, setF] = useState({ name: "", phone: "", email: "", visit_date: "", group_size: 1, note: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/public/museum-bookings", { ...f, group_size: Number(f.group_size), email: f.email || null });
      toast.success(`Visit requested. Reference ${r.data.ref}`);
      onDone(r.data.ref);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="grid gap-3" data-testid="museum-booking-form">
      <input required className="field" placeholder="Full name" value={f.name} onChange={set("name")} data-testid="booking-name" />
      <div className="grid grid-cols-2 gap-3">
        <input required className="field" placeholder="Phone" value={f.phone} onChange={set("phone")} data-testid="booking-phone" />
        <input className="field" type="email" placeholder="Email (optional)" value={f.email} onChange={set("email")} data-testid="booking-email" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <input required className="field" type="date" value={f.visit_date} onChange={set("visit_date")} data-testid="booking-date" />
        <input required className="field" type="number" min="1" max="200" value={f.group_size} onChange={set("group_size")} data-testid="booking-group-size" />
      </div>
      <textarea className="field" rows={2} placeholder="Notes (school trip, accessibility…)" value={f.note} onChange={set("note")} data-testid="booking-note" />
      <button disabled={busy} className="btn-gold" data-testid="booking-submit-btn">{busy ? "Sending…" : "Request visit"}</button>
      <p className="text-[11px] text-slate-500">Open daily 10:00–20:00 in hourly sessions · GHS 200 per person · children under 12 book separately. Source: despiteautomuseum.com</p>
    </form>
  );
};

export const Museum = () => {
  const [open, setOpen] = useState(false);
  const [ref, setRef] = useState(null);
  return (
    <section id="museum" className="max-w-7xl mx-auto px-5 md:px-8 py-20" data-testid="museum-section">
      <div className="grid lg:grid-cols-5 gap-8 items-end">
        <div className="lg:col-span-2">
          <SectionHead eyebrow="Despite Automobile Museum · East Legon, Accra" title="A gallery of motoring legends">
            Opened in 2025 and commissioned by the Asantehene, Otumfuo Osei Tutu II — Ghana's first-ever auto museum, with 85+ remarkable automobiles.
          </SectionHead>
          <div className="flex gap-2"><button onClick={() => { setRef(null); setOpen(true); }} className="btn-gold" data-testid="museum-book-btn">Book a visit</button><Link to="/museum" className="btn-ghost" data-testid="museum-explore-link">Explore the museum</Link></div>
          {ref && <p className="mt-3 font-data text-xs text-gold" data-testid="booking-ref">Reference: {ref}</p>}
        </div>
        <div className="lg:col-span-3 grid grid-cols-3 grid-rows-2 gap-3 h-[380px]">
          {IMGS.map((src, i) => (
            <div key={src} className={`overflow-hidden rounded-sm relative ${i === 0 ? "col-span-2 row-span-2" : ""}`} data-testid={`museum-tour-img-${i}`}>
              <img src={src} alt="Despite Automobile Museum" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" loading="lazy" />
            </div>
          ))}
        </div>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white border-[color:var(--line)]" data-testid="museum-booking-dialog">
          <DialogHeader><DialogTitle className="font-display text-gold">Book a museum visit</DialogTitle></DialogHeader>
          <BookingForm onDone={(r) => { setRef(r); setOpen(false); }} />
        </DialogContent>
      </Dialog>
    </section>
  );
};
